// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConfigSettingsForm-space1-JODmu {
	margin-bottom: 6px !important;
}

.ConfigSettingsForm-space2-VkiMO {
	margin-bottom: 12px !important;
}

.ConfigSettingsForm-space3-ihlkT {
	margin-bottom: 18px !important;
}

.ConfigSettingsForm-space4-wyu9a {
	margin-bottom: 24px !important;
}

.ConfigSettingsForm-space5-vAofX {
	margin-bottom: 30px !important;
}

.ConfigSettingsForm-space6-qEL9p {
	margin-bottom: 36px !important;
}

.ConfigSettingsForm-space7-nUbjV {
	margin-bottom: 42px !important;
}

.ConfigSettingsForm-space8-_Dm5d {
	margin-bottom: 48px !important;
}

.ConfigSettingsForm-spaceTop1-eNyIb {
	margin-top: 6px !important;
}

.ConfigSettingsForm-spaceTop2-D3f9F {
	margin-top: 12px !important;
}

.ConfigSettingsForm-spaceTop3-Uzft5 {
	margin-top: 18px !important;
}

.ConfigSettingsForm-spaceTop4-Pnmjz {
	margin-top: 24px !important;
}

.ConfigSettingsForm-spaceTop5-FeK7K {
	margin-top: 30px !important;
}

.ConfigSettingsForm-spaceTop6-at0U7 {
	margin-top: 36px !important;
}

.ConfigSettingsForm-spaceTop7-dhmT3 {
	margin-top: 42px !important;
}

.ConfigSettingsForm-spaceTop8-pJ5YM {
	margin-top: 48px !important;
}

.ConfigSettingsForm-noMargin-PeOhJ {
	margin: 0px !important;
}

.ConfigSettingsForm-padding1-J6Rwc {
	padding-bottom: 6px !important;
}

.ConfigSettingsForm-padding2-xxA36 {
	padding-bottom: 12px !important;
}

.ConfigSettingsForm-padding3-g52GM {
	padding-bottom: 18px !important;
}

.ConfigSettingsForm-padding4-W8SO0 {
	padding-bottom: 24px !important;
}

.ConfigSettingsForm-padding5-VU4Cf {
	padding-bottom: 30px !important;
}

.ConfigSettingsForm-padding6-fV6R0 {
	padding-bottom: 36px !important;
}

.ConfigSettingsForm-padding7-wgVQM {
	padding-bottom: 42px !important;
}

.ConfigSettingsForm-paddingTop1-kcXHO {
	padding-top: 6px !important;
}

.ConfigSettingsForm-paddingTop2-fNQlW {
	padding-top: 12px !important;
}

.ConfigSettingsForm-paddingTop3-GzGaV {
	padding-top: 18px !important;
}

.ConfigSettingsForm-paddingTop4-ahEBu {
	padding-top: 24px !important;
}

.ConfigSettingsForm-paddingTop5-DfPAz {
	padding-top: 30px !important;
}

.ConfigSettingsForm-paddingTop6-E4o05 {
	padding-top: 36px !important;
}

.ConfigSettingsForm-paddingTop7-eooNc {
	padding-top: 42px !important;
}

.ConfigSettingsForm-noPadding-FQshd {
	padding: 0px !important;
}

.ConfigSettingsForm-spaceMarginBottom0-tHqWp {
	margin-bottom: 0;
}

.ConfigSettingsForm-textBold-W_3Nf {
	font-weight: 500 !important;
}

.ConfigSettingsForm-textBolder-mAncO {
	font-weight: 700 !important;
}

.ConfigSettingsForm-textNormal-h7n1v {
	font-weight: normal !important;
}

/*New Design Text Colors */

.ConfigSettingsForm-textDarkBlue-PH4t8 {
	color: rgb(20, 39, 94) !important;
}

.ConfigSettingsForm-textLightBlue-Exa6R {
	color: rgb(57, 87, 106) !important;
}

.ConfigSettingsForm-textLightSandleGreen-HWSQD {
	color: rgb(76, 86, 41) !important;
}

.ConfigSettingsForm-textLightBrown-ZvSSG {
	color: rgb(115, 79, 33) !important;
}

.ConfigSettingsForm-textMediumMaroon-XFZ10 {
	color: rgb(87, 37, 51) !important;
}

.ConfigSettingsForm-textBrown-yZqmp {
	color: rgb(160, 47, 24) !important;
}

.ConfigSettingsForm-textMaroon-gobL8 {
	color: rgb(155, 49, 67) !important;
}

.ConfigSettingsForm-textDarkBrown-ZdH3Z {
	color: rgb(83, 18, 16) !important;
}

.ConfigSettingsForm-textMediumBrown-vIcp2 {
	color: rgb(142, 28, 10) !important;
}

.ConfigSettingsForm-textSkyBlue-i3WMV {
	color: rgb(37, 117, 141) !important;
}

.ConfigSettingsForm-textGray-R_m6v {
	color: rgb(77, 65, 51) !important;
}

.ConfigSettingsForm-errorMessage-NAFRu {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.ConfigSettingsForm-userText-uEQe5 {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.ConfigSettingsForm-panelHeader-RMDbK {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.ConfigSettingsForm-exportSection-elx8T {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.ConfigSettingsForm-exportSectionGridSub-bIU6D {
	grid-template-columns: 50% 49% !important;
}

.ConfigSettingsForm-exportText-om9nr {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.ConfigSettingsForm-exportLinkImg-OnV5K {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.ConfigSettingsForm-exportImg-Cei6Z {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ConfigSettingsForm-linkBtn-GDzSS {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.ConfigSettingsForm-table-eTIz5 {
	display: table;
}

.ConfigSettingsForm-tableRow-Awxnd {
	display: table-row;
}

.ConfigSettingsForm-tableCell-hmvSM {
	display: table-cell;
	float: none;
}

.ConfigSettingsForm-formGroup-yyPkH {
	margin-bottom: 6px;
}

.ConfigSettingsForm-marginTop0-EaPh7 {
	margin-top: 0;
}

.ConfigSettingsForm-marginBottom20-U1r2N {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.ConfigSettingsForm-bannerImageBg-Dxrb4 {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.ConfigSettingsForm-bannerDelete-Icxh7 {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.ConfigSettingsForm-exportLink-HWMkr {
	padding-top: 10px;
	padding-right: 10px;
}

.ConfigSettingsForm-seachContent-iLww5 {
	padding-left: 0px;
	margin-bottom: 5px;
}

.ConfigSettingsForm-marginBottom9-CYoum {
	margin-bottom: 9px;
}

.ConfigSettingsForm-spaceTop52-MpeA_ {
	margin-top: 52px;
}

.ConfigSettingsForm-profileViewInner-wag6u {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.ConfigSettingsForm-profileViewMain-QEe4U {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.ConfigSettingsForm-profileViewlabel-Ht_JH {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.ConfigSettingsForm-profileViewMainContent-pjNSn {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.ConfigSettingsForm-reviewsFormStar-TI8JW {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.ConfigSettingsForm-reviewsFormStar-TI8JW svg {
	cursor: pointer;
}

.ConfigSettingsForm-addLanguageText-Y3Ib_ {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.ConfigSettingsForm-exportSection-elx8T {
		grid-template-columns: 100%;
	}

	.ConfigSettingsForm-spaceTop52-MpeA_ {
		margin-top: 18px;
	}

	.ConfigSettingsForm-exportText-om9nr {
		float: none;
		margin-top: 12px;
	}

	.ConfigSettingsForm-exportSectionGridSub-bIU6D {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.ConfigSettingsForm-profileViewlabel-Ht_JH {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ConfigSettingsForm-profileViewMainContent-pjNSn {
		width: 100%;
		text-align: center;
	}

	.ConfigSettingsForm-panelHeader-RMDbK {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.ConfigSettingsForm-divider-zC1C3 {
    margin: 18px 0;
    border-top: 1px solid var(--primary-border) !important;
}

.ConfigSettingsForm-gatewayLogoSetting-PwNu3 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 16px;
  margin: 16px 0 24px;
}

.ConfigSettingsForm-gatewayLogoPreview-JsZFY {
  width: 88px;
  height: 52px;
  padding: 8px;
  -o-object-fit: contain;
     object-fit: contain;
  border: 1px solid #d8dbe4;
  border-radius: 8px;
  background: #fff;
}

.ConfigSettingsForm-gatewayLogoUpload-jTtbp {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  min-height: 38px;
  padding: 8px 14px;
  margin: 0;
  border: 1px solid #d8dbe4;
  border-radius: 6px;
  cursor: pointer;
}

.ConfigSettingsForm-gatewayLogoUpload-jTtbp input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/ConfigSettingsForm/ConfigSettingsForm.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACpN3E;IACI,cAAc;IACd,sDAAsD;AAC1D;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n@import '../../helpers.css';\n\n\n.divider {\n    margin: 18px 0;\n    border-top: 1px solid var(--primary-border) !important;\n}\n.gatewayLogoSetting {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin: 16px 0 24px;\n}\n\n.gatewayLogoPreview {\n  width: 88px;\n  height: 52px;\n  padding: 8px;\n  object-fit: contain;\n  border: 1px solid #d8dbe4;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.gatewayLogoUpload {\n  display: inline-flex;\n  align-items: center;\n  min-height: 38px;\n  padding: 8px 14px;\n  margin: 0;\n  border: 1px solid #d8dbe4;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.gatewayLogoUpload input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ConfigSettingsForm-space1-JODmu`,
	"space2": `ConfigSettingsForm-space2-VkiMO`,
	"space3": `ConfigSettingsForm-space3-ihlkT`,
	"space4": `ConfigSettingsForm-space4-wyu9a`,
	"space5": `ConfigSettingsForm-space5-vAofX`,
	"space6": `ConfigSettingsForm-space6-qEL9p`,
	"space7": `ConfigSettingsForm-space7-nUbjV`,
	"space8": `ConfigSettingsForm-space8-_Dm5d`,
	"spaceTop1": `ConfigSettingsForm-spaceTop1-eNyIb`,
	"spaceTop2": `ConfigSettingsForm-spaceTop2-D3f9F`,
	"spaceTop3": `ConfigSettingsForm-spaceTop3-Uzft5`,
	"spaceTop4": `ConfigSettingsForm-spaceTop4-Pnmjz`,
	"spaceTop5": `ConfigSettingsForm-spaceTop5-FeK7K`,
	"spaceTop6": `ConfigSettingsForm-spaceTop6-at0U7`,
	"spaceTop7": `ConfigSettingsForm-spaceTop7-dhmT3`,
	"spaceTop8": `ConfigSettingsForm-spaceTop8-pJ5YM`,
	"noMargin": `ConfigSettingsForm-noMargin-PeOhJ`,
	"padding1": `ConfigSettingsForm-padding1-J6Rwc`,
	"padding2": `ConfigSettingsForm-padding2-xxA36`,
	"padding3": `ConfigSettingsForm-padding3-g52GM`,
	"padding4": `ConfigSettingsForm-padding4-W8SO0`,
	"padding5": `ConfigSettingsForm-padding5-VU4Cf`,
	"padding6": `ConfigSettingsForm-padding6-fV6R0`,
	"padding7": `ConfigSettingsForm-padding7-wgVQM`,
	"paddingTop1": `ConfigSettingsForm-paddingTop1-kcXHO`,
	"paddingTop2": `ConfigSettingsForm-paddingTop2-fNQlW`,
	"paddingTop3": `ConfigSettingsForm-paddingTop3-GzGaV`,
	"paddingTop4": `ConfigSettingsForm-paddingTop4-ahEBu`,
	"paddingTop5": `ConfigSettingsForm-paddingTop5-DfPAz`,
	"paddingTop6": `ConfigSettingsForm-paddingTop6-E4o05`,
	"paddingTop7": `ConfigSettingsForm-paddingTop7-eooNc`,
	"noPadding": `ConfigSettingsForm-noPadding-FQshd`,
	"spaceMarginBottom0": `ConfigSettingsForm-spaceMarginBottom0-tHqWp`,
	"textBold": `ConfigSettingsForm-textBold-W_3Nf`,
	"textBolder": `ConfigSettingsForm-textBolder-mAncO`,
	"textNormal": `ConfigSettingsForm-textNormal-h7n1v`,
	"textDarkBlue": `ConfigSettingsForm-textDarkBlue-PH4t8`,
	"textLightBlue": `ConfigSettingsForm-textLightBlue-Exa6R`,
	"textLightSandleGreen": `ConfigSettingsForm-textLightSandleGreen-HWSQD`,
	"textLightBrown": `ConfigSettingsForm-textLightBrown-ZvSSG`,
	"textMediumMaroon": `ConfigSettingsForm-textMediumMaroon-XFZ10`,
	"textBrown": `ConfigSettingsForm-textBrown-yZqmp`,
	"textMaroon": `ConfigSettingsForm-textMaroon-gobL8`,
	"textDarkBrown": `ConfigSettingsForm-textDarkBrown-ZdH3Z`,
	"textMediumBrown": `ConfigSettingsForm-textMediumBrown-vIcp2`,
	"textSkyBlue": `ConfigSettingsForm-textSkyBlue-i3WMV`,
	"textGray": `ConfigSettingsForm-textGray-R_m6v`,
	"errorMessage": `ConfigSettingsForm-errorMessage-NAFRu`,
	"userText": `ConfigSettingsForm-userText-uEQe5`,
	"panelHeader": `ConfigSettingsForm-panelHeader-RMDbK`,
	"exportSection": `ConfigSettingsForm-exportSection-elx8T`,
	"exportSectionGridSub": `ConfigSettingsForm-exportSectionGridSub-bIU6D`,
	"exportText": `ConfigSettingsForm-exportText-om9nr`,
	"exportLinkImg": `ConfigSettingsForm-exportLinkImg-OnV5K`,
	"exportImg": `ConfigSettingsForm-exportImg-Cei6Z`,
	"linkBtn": `ConfigSettingsForm-linkBtn-GDzSS`,
	"table": `ConfigSettingsForm-table-eTIz5`,
	"tableRow": `ConfigSettingsForm-tableRow-Awxnd`,
	"tableCell": `ConfigSettingsForm-tableCell-hmvSM`,
	"formGroup": `ConfigSettingsForm-formGroup-yyPkH`,
	"marginTop0": `ConfigSettingsForm-marginTop0-EaPh7`,
	"marginBottom20": `ConfigSettingsForm-marginBottom20-U1r2N`,
	"bannerImageBg": `ConfigSettingsForm-bannerImageBg-Dxrb4`,
	"bannerDelete": `ConfigSettingsForm-bannerDelete-Icxh7`,
	"exportLink": `ConfigSettingsForm-exportLink-HWMkr`,
	"seachContent": `ConfigSettingsForm-seachContent-iLww5`,
	"marginBottom9": `ConfigSettingsForm-marginBottom9-CYoum`,
	"spaceTop52": `ConfigSettingsForm-spaceTop52-MpeA_`,
	"profileViewInner": `ConfigSettingsForm-profileViewInner-wag6u`,
	"profileViewMain": `ConfigSettingsForm-profileViewMain-QEe4U`,
	"profileViewlabel": `ConfigSettingsForm-profileViewlabel-Ht_JH`,
	"profileViewMainContent": `ConfigSettingsForm-profileViewMainContent-pjNSn`,
	"reviewsFormStar": `ConfigSettingsForm-reviewsFormStar-TI8JW`,
	"addLanguageText": `ConfigSettingsForm-addLanguageText-Y3Ib_`,
	"divider": `ConfigSettingsForm-divider-zC1C3`,
	"gatewayLogoSetting": `ConfigSettingsForm-gatewayLogoSetting-PwNu3`,
	"gatewayLogoPreview": `ConfigSettingsForm-gatewayLogoPreview-JsZFY`,
	"gatewayLogoUpload": `ConfigSettingsForm-gatewayLogoUpload-jTtbp`
};
module.exports = ___CSS_LOADER_EXPORT___;
